import React, { useEffect } from "react";
import Page from "../../common/layout/Page";
import Pagination from "../../common/Pagination";
import useFailedJobs from "./useFailedJobs";
import FailedJobsFilters from "./FailedJobsFilters";
import FailedJobsList from "./FailedJobsList";

const FailedJobsPage = () => {
  const { failedJobs, filters, isLoading, pagination, actions } =
    useFailedJobs();

  useEffect(() => {
    actions.fetchFailedJobs();
  }, []);

  return (
    <Page
      title="Jobs échoués"
      subTitle="Gestion des jobs en erreur"
      titleMargin="mb-2"
    >
      <div className="mb-3">
        <FailedJobsFilters
          filters={filters}
          onFilterChange={actions.handleFilterChange}
          onSearch={() => actions.fetchFailedJobs()}
          onReset={actions.resetFilters}
        />
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <small className="text-muted">
          {pagination.count} résultat{pagination.count > 1 ? "s" : ""}
        </small>
        <Pagination
          page={pagination.page}
          nbPages={pagination.totalPages}
          changePage={actions.changePage}
        />
      </div>

      <FailedJobsList
        jobs={failedJobs}
        isLoading={isLoading}
        onRetry={actions.retryJob}
        onDelete={actions.deleteJob}
      />

      <div className="mt-3">
        <Pagination
          page={pagination.page}
          nbPages={pagination.totalPages}
          changePage={actions.changePage}
        />
      </div>
    </Page>
  );
};

export default FailedJobsPage;
